import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'session',
  initialState: {
    server: null,
    user: null,
    socket: null,
    includeLogs: false,
    logCollectionIdentifier: '',
    logs: [],
    positions: {},
    history: {},
  },
  reducers: {
    updateServer(state, action) {
      state.server = action.payload;
    },
    updateUser(state, action) {
      state.user = action.payload;
    },
    updateSocket(state, action) {
      state.socket = action.payload;
    },
    enableLogs(state, action) {
      state.includeLogs = action.payload;
      if (!action.payload) {
        state.logs = [];
      }
    },
    setLogCollectionIdentifier(state, action) {
      state.logCollectionIdentifier = String(action.payload || '').trim().toLowerCase();
      state.logs = [];
    },
    updateLogs(state, action) {
      const identifier = state.logCollectionIdentifier;
      const incoming = identifier
        ? action.payload.filter((item) => String(item.uniqueId || '').toLowerCase().includes(identifier)
          || String(item.data || '').toLowerCase().includes(identifier))
        : action.payload;

      if (!incoming.length) {
        return;
      }

      state.logs.push(...incoming);
      if (state.logs.length > 200) {
        state.logs.splice(0, state.logs.length - 200);
      }
    },
    clearLogs(state) {
      state.logs = [];
    },
    updatePositions(state, action) {
      const liveRoutes = state.user.attributes.mapLiveRoutes || state.server.attributes.mapLiveRoutes || 'none';
      const liveRoutesLimit = state.user.attributes['web.liveRouteLength'] || state.server.attributes['web.liveRouteLength'] || 10;
      action.payload.forEach((position) => {
        state.positions[position.deviceId] = position;
        if (liveRoutes !== 'none') {
          const route = state.history[position.deviceId] || [];
          const last = route.at(-1);
          if (!last || (last[0] !== position.longitude && last[1] !== position.latitude)) {
            state.history[position.deviceId] = [...route.slice(1 - liveRoutesLimit), [position.longitude, position.latitude]];
          }
        } else {
          state.history = {};
        }
      });
    },
  },
});

export { actions as sessionActions };
export { reducer as sessionReducer };
